import baseAPI from './axiosApi'

const api={
    dicts:'/api-d/dicts',
    refresh:'/api-d/dicts/refresh',
    getDicts:'/api-d/dicts/getDicts'
}
// 查询字典
export function list (data) {
    return baseAPI.axiosData(api.dicts,'get',data)
}
// 下拉查询字典
export function getDicts (data) {
    return baseAPI.axiosData(api.getDicts,'get',data)
}
// 新增字典
export function add (data) {
    return baseAPI.axiosData(api.dicts,'post',data)
}
// 修改字典
export function edit (data) {
    return baseAPI.axiosData(api.dicts,'put',data)
}
// 删除字典
export function del (id) {
    return baseAPI.axiosData(api.dicts+'/'+id,'delete')
}
// 刷新字典缓存
export function refresh () {
    return baseAPI.axiosData(api.refresh,'get')
}